export default{S:"16px",M:"34px",L:"52px",XL:"70px",XXL:"100px"};
